import React from 'react'
import Head from 'next/head'
import ChromatogramSearchPage from '@src/routes/ChromatogramSearch'
import { useIntl } from 'react-intl'

const ChromatogramSearch = () => {
  const intl = useIntl()

  return (
    <React.Fragment>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'CHROMATOGRAM_SEARCH',
            defaultMessage: 'Chromatogram Search',
          })}
        </title>
      </Head>
      <ChromatogramSearchPage />
    </React.Fragment>
  )
}
export default ChromatogramSearch
